import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider, useAuth } from './context/AuthContext';
import LandingPage from './pages/LandingPage';
import SignupPage from './pages/SignupPage';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import GamePage from './pages/GamePage';
import GameRedirectPage from './pages/GameRedirectPage';
import QRCodePage from './pages/QRCodePage';
import RedeemPage from './pages/RedeemPage';
import DashboardLayout from './pages/dashboard/DashboardLayout';
import DashboardHome from './pages/dashboard/DashboardHome';
import GamesPage from './pages/dashboard/GamesPage';
import CustomersPage from './pages/dashboard/CustomersPage';
import ReviewsPage from './pages/dashboard/ReviewsPage';
import AnalyticsPage from './pages/dashboard/AnalyticsPage';
import SettingsPage from './pages/dashboard/SettingsPage';
import CheckoutPage from './pages/CheckoutPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import RefundPage from './pages/RefundPage';
import ContactPage from './pages/ContactPage';
import BoutiquePage from './pages/BoutiquePage';
import './App.css';

const PrivateRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  
  // Show loading spinner while Firebase is initializing
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-sky-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-[#2E59D7] mx-auto mb-4"></div>
          <p className="text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }
  
  // Only redirect if we're sure there's no user (loading is complete)
  if (!currentUser) {
    console.log('PrivateRoute: No user found, redirecting to login');
    return <Navigate to="/login" replace />;
  }
  
  console.log('PrivateRoute: User authenticated, showing dashboard');
  return children;
};

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/jeu/:slug" element={<GameRedirectPage />} />
            <Route path="/game/:gameType/:userId" element={<GamePage />} />
            <Route path="/qrcode/:redemptionCode" element={<QRCodePage />} />
            <Route path="/redeem/:redemptionCode" element={<RedeemPage />} />
            <Route path="/checkout/:plan" element={<CheckoutPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/refund" element={<RefundPage />} />
            <Route path="/contact" element={<ContactPage />} />
            
            <Route path="/dashboard" element={<PrivateRoute><DashboardLayout /></PrivateRoute>}>
              <Route index element={<DashboardHome />} />
              <Route path="games" element={<GamesPage />} />
              <Route path="customers" element={<CustomersPage />} />
              <Route path="reviews" element={<ReviewsPage />} />
              <Route path="analytics" element={<AnalyticsPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>
            
            <Route path="/checkout/basic" element={<PrivateRoute><BoutiquePage /></PrivateRoute>} />
            <Route path="/boutique" element={<PrivateRoute><BoutiquePage /></PrivateRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </AuthProvider>
  );
}

export default App;